function slugify(label: string): string {
  return label
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
}

/** Deriva o módulo (ex.: "viagens", "grupos_empresariais") a partir do pathname da rota interna. */
export function moduleFromPathname(pathname: string): string {
  const segment = pathname.split('/').filter(Boolean)[0]
  if (!segment) return 'login'
  return slugify(segment.replace(/-/g, ' '))
}

/** Para itens de menu externos (ex.: Relatórios), cujo `to` é uma URL e não um pathname interno. */
export function moduleFromLabel(label: string): string {
  return slugify(label)
}
